import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TenantConfigurationService {
  isReadMode = signal(true);
  isAddNewTenantDialogOpen = signal(false);
  isAddNewContractDialogOpen = signal(false);

  toggleAddNewTenantDialog() {
    this.isAddNewTenantDialogOpen.update((state) => !state);
  }

  toggleAddNewContractDialog() {
    this.isAddNewContractDialogOpen.update((state) => !state);
  }
}
